import type { AxiosRequestConfig } from 'axios';
import merge from 'deepmerge';

/*
 * Merge caller-supplied axios options over the per-request defaults.
 *
 * deepmerge deep-clones non-plain source objects, which turns an AbortSignal
 * into a plain {} with no addEventListener. axios then throws
 * "signal.addEventListener is not a function" while wiring up cancellation, so
 * the merged config's signal must be the caller's original reference, not the
 * cloned husk. Restore it explicitly after merging.
 */
export function mergeRequestOptions(
	defaultRequestOptions: AxiosRequestConfig,
	requestOptions?: AxiosRequestConfig,
): AxiosRequestConfig {
	if (!requestOptions) {
		return defaultRequestOptions;
	}

	const merged = merge(
		defaultRequestOptions,
		requestOptions,
	);

	if (requestOptions.signal) {
		merged.signal = requestOptions.signal;
	}

	return merged;
}
